import { useMutation } from "@apollo/react-hooks";
import { Modal } from "@shopify/polaris";
import React, { useCallback } from "react";
import { PICK_AMAZON_IDEA } from "../../../graphql/mutations/amazon-idea";
import { arrInvalid, handleError } from "../../../helper";
import useTimeout from "../../../hooks/useTimeout";
import { useToastContext } from "../../shared/ToastContext";
import { useAmazonIdeaCtx } from "../context";

export default function AmazonIdeaPick({ open, onClose, ids, onCompleted }) {
    const { setNotify, toggleToast } = useToastContext();
    const { refetch } = useAmazonIdeaCtx();

    const [setDelay] = useTimeout();
    const [pickAmazonIdea, { loading }] = useMutation(PICK_AMAZON_IDEA, {
        onCompleted: () => {
            setNotify({
                msg: "Pick amazon idea successfully",
                err: false,
            });

            onClose();
            onCompleted && onCompleted();
            setDelay(() => {
                refetch && refetch();
            }, 1500);
        },
        onError: (err) => {
            setNotify({ msg: handleError(err?.toString()), err: true });
        },
    });

    const handleSubmit = useCallback(() => {
        if (arrInvalid(ids)) return;

        toggleToast && toggleToast(true);
        setNotify && setNotify({ msg: null, err: false });

        pickAmazonIdea({
            variables: {
                ids,
            },
        });
    }, [ids]);

    return (
        <Modal
            open={open}
            onClose={onClose}
            sectioned
            title="Pick Amazon Idea"
            primaryAction={{
                content: "Submit",
                onAction: handleSubmit,
                loading: loading,
            }}
            secondaryActions={[{ content: "Cancel", onAction: onClose }]}
        >
            <p>Are you sure to pick this Idea?</p>
        </Modal>
    );
}
